<template>
    <div>
      <h3
        v-if="!isAddEquipmentMode"
        class="editor-header"
      >
        {{ $t('post.title') }}
      </h3>
      <location-deviation
        v-if="!isAddEquipmentMode"
        :location-deviation="item.location_deviation"
      />
      <div class="px-2">
        <div class="row" v-if="!isAddEquipmentMode">
          <div class="col-sm-6">
            <span class="span-title">{{ $t('common.id') }}</span>
            <span class="item-detail-text">{{ item.external_system_id }}</span>
          </div>
          <div class="col-sm-6">
            <road-addess-view
              :road-number="item.road_num"
              :section-number="item.road_sec"
              :distance="item.distance"
              :show-street-name="false"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 nopads pr-1 pl-1">
            <span class="span-title">{{ $t('post.type') }}</span>
              <select
                  v-model="item.type"
                  :class="['form-select', 'form-select-sm', validateIsNumber(item.type) === true ? 'is-valid' : validateIsNumber(item.type) === false ? 'is-invalid' : '']"
              >
                  <option :value="null" disabled>
                      {{ $t('post.select_type') }}
                  </option>
                  <option
                      v-for="item in getPostTypes()"
                      :key="item.value"
                      :value="item.value"
                  >
                      {{ item.name }}
                  </option>
              </select>
          </div>
          <div class="col-sm-6 nopads pr-1 pl-1">
            <condition-selector
              v-model="item.condition"
              :required="true"
            />
          </div>
        </div>
       <div class="row">
          <div class="col-sm-6 nopads pr-1 pl-1">
            <span class="span-title">{{ $t('post.material') }}</span>
              <select
                  v-model="item.material"
                  class="form-select form-select-sm"
              >
                  <option :value="null" disabled>
                      {{ $t('culvert.select_material') }}
                  </option>
                  <option
                      v-for="item in getPostMaterials()"
                      :key="item.value"
                      :value="item.value"
                  >
                      {{ item.name }}
                  </option>
              </select>
          </div>
          <div class="col-sm-6 nopads pr-1 pl-1">
            <span class="span-title">{{ $t('post.code') }}</span>
              <input
                  id="code"
                  v-model="item.code"
                  type="text"
                  class="form-control form-control-sm"
              />
          </div>
        </div>
        <location-details
              v-if="!isAddEquipmentMode"
              :lane-data="item.location_specification.lane"
              :side-data="item.location_specification.side"
              :track-data="item.location_specification.tracks"
        />
       <div class="row">
          <div class="col-sm-6 nopads pr-1 pl-1">
            <span class="span-title">{{ $t('post.stand_type.title') }}</span>
              <select
                  v-model="item.stand_type"
                  class="form-select form-select-sm"
              >
                  <option :value="null" disabled>
                      {{ $t('post.stand_type.select_type') }}
                  </option>
                  <option
                      v-for="item in getStandPostTypes()"
                      :key="item.value"
                      :value="item.value"
                  >
                      {{ item.name }}
                  </option>
              </select>
          </div>
          <div class="col-sm-6 nopads pr-1 pl-1">
            <span class="span-title">{{ $t('post.stand_material.title') }}</span>
              <select
                  v-model="item.stand_material"
                  class="form-select form-select-sm"
              >
                  <option :value="null" disabled>
                      {{ $t('culvert.select_material') }}
                  </option>
                  <option
                      v-for="item in getStandMaterials()"
                      :key="item.value"
                      :value="item.value"
                  >
                      {{ item.name }}
                  </option>
              </select>
          </div>
        </div>
       <div class="row">
          <div class="col-sm-6 nopads pr-1 pl-1">
            <span class="span-title">{{ $t('post.length') }}</span>
              <input
                  id="value"
                  v-model="item.length"
                  min="1"
                  type="number"
                  class="form-control form-control-sm"
                  size="sm"
              />
          </div>
          <div class="col-sm-6 nopads pr-1 pl-1">
            <span class="span-title">{{ $t('post.height') }}</span>
              <input
                  id="height"
                  v-model="item.height"
                  min="1"
                  type="number"
                  class="form-control form-control-sm"
                  size="sm"
              />
          </div>
        </div>
       <div class="row">
          <div class="col-sm-6 nopads pr-1 pl-1">
            <span class="span-title">{{ $t('post.thickness.title') }}</span>
              <select
                  v-model="item.thickness"
                  class="form-select form-select-sm"
                  aria-label="Select Thickness"
              >
                  <option value="null" disabled>
                      {{ $t('post.select_thickness') }}
                  </option>
                  <option
                      v-for="item in getPostThicknesses()"
                      :key="item.value"
                      :value="item.value"
                  >
                      {{ item.name }}
                  </option>
              </select>
          </div>
          <div class="col-sm-6 nopads pr-1 pl-1">
            <span class="span-title">{{ $t('post.product_name') }}</span>
              <input
                  id="productName"
                  v-model="item.product_name"
                  type="text"
                  class="form-control form-control-sm"
              />
          </div>
        </div>
       <div class="row">
          <div class="col-sm-4">
            <span class="span-title">{{ $t('post.crash_safety') }}</span>
              <input
                  id="crashSafety"
                  v-model="item.crash_safety"
                  type="checkbox"
                  class="form-check-input form-check-input-sm"
              />
          </div>
          <div class="col-sm-4">
            <span class="span-title">{{ $t('post.detachable') }}</span>
              <input
                  id="detachable"
                  v-model="item.detachable"
                  type="checkbox"
                  class="form-check-input form-check-input-sm"
              />
          </div>
          <div class="col-sm-4">
            <span class="span-title">{{ $t('post.electrified') }}</span>
              <input
                  id="electrified"
                  v-model="item.electrified"
                  type="checkbox"
                  class="form-check-input form-check-input-sm"
              />
          </div>
        </div>
        <div v-if="isAddEquipmentMode" class="row">
          <div class="col-sm-4">
            <location-deviation
              :edit-mode="true"
              :location-deviation="item.location_deviation"
              @update-location-deviation="updateLocationDeviation"
            />
          </div>
        </div>
        <div v-if="isAddEquipmentMode" class="row">
          <div class="col-sm-12 nopads mt-2">
            <velho-equipment-location-details-editor
              :road-info="item"
              :location-specification="item.location_specification"
              :tracks-required="roadPostTrackRequired(item.location_specification.side)"
              :side-required="postRoadsideRequired(item.location_deviation, item.road_num)"
              :hide-side-selector="!sideRequired(item.location_deviation)"
              :center-area-required="false"

            />
          </div>
        </div>
        <hr class="mb-0">
        <div class="row" v-if="isAddEquipmentMode">
            <div class="col-sm-6 nopads mt-2">
                <equipment-date
                    :text="$t('velho_equipment.start_date')"
                    v-model="item.created_at"
                />
            </div>
        </div>
       <div class="row">
          <div class="col-sm-12 nopads mt-2">
            <velho-equipment-damages :items="item.equipment_damages" />
          </div>
        </div>
        <equipment-actions
          v-if="!isAddEquipmentMode"
          ref="actions"
          v-model="item.actions"
        />
        <linked-equipment
          v-if="item && item.linked_equipment && item.linked_equipment.length > 0"
          :linked-equipments="item.linked_equipment"
        />
      </div>

      <velho-editor-buttons
        v-if="!isAddEquipmentMode"
        :url="extPostsUrl"
        :selected-contract="selectedContract"
        :item="item"
        :disabled="loading > 0"
        @close="close"
        @submit="handleSubmit"
        @removal-confirmed="removalConfirmed"
      />
    <div
      v-if="loading > 0"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {mapHelper} from "@/components/mixins/MapMixin";
import {postHelper} from "@/components/mixins/PostMixin";
import {conversionModelHelper} from "@/components/mixins/ConversionMixin";
import {restApi} from "@/components/mixins/RestApiMixin";
import ConditionSelector from "@/components/velho/ConditionSelector";
import {deviations, velhoHelper} from "@/components/mixins/VelhoMixin";
import EquipmentActions from "@/components/velho/EquipmentActions";
import VelhoEditorButtons from "@/components/velho/VelhoEditorButtons";
import LinkedEquipment from "@/components/velho/LinkedEquipment";
import LocationDeviation from "@/components/velho/LocationDeviation";
import LocationDetails from "@/components/velho/LocationDetails";
import VelhoEquipmentLocationDetailsEditor from "@/components/velho/VelhoEquipmentLocationDetailsEditor";
import VelhoEquipmentDamages from "@/components/velho/VelhoEquipmentDamages";
import RoadAddessView from "@/components/velho/RoadAddressView";
import {velhoValidationMixin} from "@/components/mixins/VelhoValidationMixin";
import {velhoRequiredMixin} from "@/components/mixins/VelhoRequiredMixin";
import EquipmentDate from "@/components/velho/EquipmentDate.vue";

export default {
    name: 'PostEditor',
    components: {
        EquipmentDate,
        RoadAddessView,
        LocationDetails, VelhoEquipmentLocationDetailsEditor, VelhoEquipmentDamages, LocationDeviation,
        VelhoEditorButtons, EquipmentActions, ConditionSelector, LinkedEquipment},
    mixins: [mapHelper, postHelper, conversionModelHelper, restApi, velhoHelper, velhoValidationMixin, velhoRequiredMixin],
    props: {
        item: {
            type: Object,
            default: null
        },
        selectedContract: {
            type: Object,
            default: null
        },
        addEquipmentEditor: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            addEquipmentMode: this.addEquipmentEditor,
            map: null,
            loading: false,
        }
    },
    computed: {
        isAddEquipmentMode() {
            return this.addEquipmentMode
        }
    },
    methods: {
        handleSubmit: function(url, item, selectedContract, replace = false) {
            if(replace) {
                this.submitEquipmentsreplace(this.extEquipmentsReplaceUrl, [item], selectedContract)
            } else {
                this.submitEquipment(url, item, selectedContract);
            }
        },
        close: function () {
            this.$emit('close')
        },
        updateLocationDeviation(value) {
            this.item.location_deviation = value
            if(value == deviations.AT_THE_END_OF_THE_ROAD) {
                this.item.location_specification.side = null
            }
        },
        isValidForm: function() {
            if(!this.item) { return false }
            if(!this.validateRoadNumber(this.item.road_num)) { return false }
            if(!this.validateRoadSection(this.item.road_sec)) { return false }
            if(!this.validateRoadDistance(this.item.distance)) { return false }
            if(!this.validateIsNumber(this.item.type)) { return false }
            if(!this.validateIsNumber(this.item.condition)) { return false }
            if(this.roadPostTrackRequired(this.item.location_specification.side)) {
                if(!this.validateRoadTracks(this.item.location_specification.tracks)) { return false }
            }
            if(this.postRoadsideRequired(this.item.location_deviation, this.item.road_num)) {
                if(!this.validateRoadSide(this.item.location_specification.side)) { return false }
            }

            return true
        }
    }
}
</script>

<style scoped>
.map-container {
    height: 30em;
    position: relative;
}

</style>

